export const defaultShareMessage =
	'Hi! Check out Event Swirl app. It’s an interactive online game-like platform inspired by the main principles of Fluxus!';
